var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"contact-btn",on:{"click":_vm.open}},[_vm._v(" Contact Us ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"nuxt-link-active",attrs:{"href":"/#/"}})])
}]

export { render, staticRenderFns }